import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { AuthService } from '../../../../../core/services/auth.service';
import { AffectationErrorModalComponent } from '../modals/affectation-error-modal/affectation-error-modal.component';

export interface AffectationErrorHandlerOptions {
  fallbackMessage?: string;
  width?: string;
  extraStatusCodes?: number[];
  logMessage?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AffectationErrorHandlerService {
  private isModalOpen = false;

  constructor(
    private dialog: MatDialog,
    private authService: AuthService,
  ) {}

  handle(error: any, options?: AffectationErrorHandlerOptions): void {
    const width = options?.width || '550px';
    const fallbackMessage =
      options?.fallbackMessage || "Vous n'avez pas les affectations nécessaires pour accéder au périmètre.";

    // Toujours afficher la modale pour les erreurs 400 (Bad Request)
    // Mais ne pas ouvrir plusieurs modales en même temps
    if (error?.status === 400 && !this.isModalOpen) {
      this.isModalOpen = true;
      const userId = this.authService.currentUserValue()?._id;

      const dialogRef = this.dialog.open(AffectationErrorModalComponent, {
        data: {
          message: error?.error?.message || fallbackMessage,
          userId,
        },
        disableClose: true,
        width,
      });

      // Réinitialiser le flag quand la modale est fermée
      dialogRef.afterClosed().subscribe(() => {
        this.isModalOpen = false;
      });
    } else {
      console.error(options?.logMessage || 'Erreur lors de la récupération du périmètre :', error);
    }
  }
}
